import React from 'react';
import { PointExpireHistoryContainerStyled } from './styled';
import { withRouter } from 'navigations/withRouter';
import { Buttons, Displays, Inputs, Modals, Tables } from 'components';
import { scrollToTopPageFN } from 'utils/functions/scrollTopPage';
import { portalService } from 'apiServices';
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import moment from 'moment';
import 'moment-timezone';
import { MdFilterAlt, MdWarningAmber } from 'react-icons/md';
import {
  parseFilterQuery,
  syncFilterUrlQuery,
} from 'utils/functions/filterQuery';
import {
  TIME_ZONE,
  formatDateTime,
  formatPoint,
  LOG_STATUS_OPTIONS,
  MISMATCH_OPTIONS,
  PERIOD_OPTIONS,
  POINT_EXPIRE_LOG_SHEET_COLS,
  POINT_EXPIRE_LOG_SHEET_HEADER,
  POINT_EXPIRE_LOG_SHEET_ROW,
  RENDER_LOG_STATUS,
  RENDER_RUN_STATUS,
  RENDER_TRIGGER,
} from 'utils/functions/pointExpire';
import { PointExpireLogDetailContainer } from '../Modals';

const FILTER_FIELDS = [
  'period_key',
  'user_id',
  'customer_cu_id',
  'status',
  'is_mismatch',
  'start_date',
  'end_date',
  'run_ref_id',
];

// ประกอบ query จากค่า filter โดยตัดค่าว่างและ "All" ('0') ทิ้ง
// (backend ไม่ได้กรอง '0' ของ period_key ให้ จึงต้องตัดฝั่งนี้)
const buildQuery = (filterValues) => {
  const searchParams = new URLSearchParams();
  FILTER_FIELDS.forEach((key) => {
    const value = filterValues[key];
    if (value && value !== '0') searchParams.set(key, value);
  });
  const query = searchParams.toString();
  return query ? `?${query}` : '';
};

const stateFromSearch = (search) => {
  const parsed = parseFilterQuery(search, FILTER_FIELDS);
  return {
    filterValues: parsed.filterValues,
    filterQuery: buildQuery(parsed.filterValues),
    currentPage: parsed.currentPage,
  };
};

// ประวัติการตัดแต้มรายลูกค้า (point_expire_log)
class PointExpireHistoryContainer extends React.Component {
  state = {
    isLoading: true,
    isBgLoading: false,
    isPeriodLoading: true,
    periodOptions: [{ label: 'All', value: '0' }],
    pagination: null,
    perPage: 10,
    data: [],
    filterKey: 0,
    renderModal: false,
    ...stateFromSearch(this.props.router.location.search),
  };

  componentDidMount() {
    const { filterQuery, currentPage } = this.state;
    scrollToTopPageFN();
    this.fetchPeriods();
    this.fetchRunInfo();
    this.handleJoinQuery(filterQuery, currentPage);
  }

  // ถ้ามาจากหน้า Run history (มี run_ref_id) ดึงข้อมูลรอบมาแสดงแทนรหัส id ที่คนอ่านไม่รู้เรื่อง
  fetchRunInfo = async () => {
    const runId = this.state.filterValues.run_ref_id;
    if (!runId) return;
    const res = await portalService.GET_POINT_EXPIRE_RUN_DETAIL(runId);
    if (res && res.status === 200) {
      this.setState({ runInfo: res.data });
    }
  };

  renderRunLabel = () => {
    const { runInfo, filterValues } = this.state;
    if (!runInfo) return filterValues.run_ref_id;
    return `ล็อต ${runInfo.period_key} • ${RENDER_TRIGGER(runInfo.trigger)} • เริ่ม ${formatDateTime(
      runInfo.started_at
    )} • ${RENDER_RUN_STATUS(runInfo.status)} • ตัด ${formatPoint(
      runInfo.success_count
    )} คน รวม ${formatPoint(runInfo.total_point)} แต้ม`;
  };

  // ตัวเลือกล็อตของ dropdown ต้องมีก่อนสร้าง InputFilter (InputFilter อ่าน options ตอน mount)
  fetchPeriods = async () => {
    let res = await portalService.GET_POINT_EXPIRE_PERIODS();
    this.setState({
      isPeriodLoading: false,
      periodOptions:
        res && res.status === 200
          ? PERIOD_OPTIONS(res.data.periods, { withAll: true })
          : [{ label: 'All', value: '0' }],
    });
  };

  fetchData = async (stringQuery) => {
    let res = await portalService.GET_POINT_EXPIRE_LOG_LIST(stringQuery);
    if (res && res.status === 200) {
      this.setState({
        data: res.data.docs,
        isLoading: false,
        pagination: {
          last_page: res.data.totalPages,
          current_page: res.data.page,
        },
      });
    } else {
      this.setState({ data: [], isLoading: false, pagination: null });
      toast.error('โหลดข้อมูลไม่สำเร็จ');
    }
  };

  handleJoinQuery = (query, page) => {
    const { perPage } = this.state;
    let joinQuery = query
      ? `${query}&limit=${perPage}&page=${page}`
      : `?limit=${perPage}&page=${page}`;
    this.setState({
      isLoading: true,
      currentPage: page,
    });
    syncFilterUrlQuery(this.props.router, query, page);
    this.fetchData(joinQuery);
  };

  handleReloadCurrentPage = () => {
    const { filterQuery, currentPage } = this.state;
    this.handleJoinQuery(filterQuery, currentPage);
  };

  // คง run_ref_id (มาจากหน้า Run history) ไว้ตอนผู้ใช้กดค้นหาด้วย filter อื่น
  handleFilterKeyword = (e) => {
    const parsed = parseFilterQuery(e, FILTER_FIELDS);
    const filterValues = {
      ...parsed.filterValues,
      run_ref_id: this.state.filterValues.run_ref_id || '',
    };
    const filterQuery = buildQuery(filterValues);
    this.setState({ filterValues, filterQuery });
    this.handleJoinQuery(filterQuery, 1);
  };

  handleClearFilter = () => {
    this.setState((prevState) => ({
      ...stateFromSearch(''),
      filterKey: prevState.filterKey + 1,
    }));
    this.handleJoinQuery('', 1);
  };

  handleClearRunFilter = () => {
    const filterValues = { ...this.state.filterValues, run_ref_id: '' };
    this.setState({ runInfo: null });
    const filterQuery = buildQuery(filterValues);
    this.setState({ filterValues, filterQuery });
    this.handleJoinQuery(filterQuery, 1);
  };

  handlePageClick = (e) => {
    const { filterQuery } = this.state;
    this.handleJoinQuery(filterQuery, e.selected + 1);
  };

  handleCloseModal = () => {
    this.setState({ renderModal: false });
  };

  handleClickDetail = (row) => {
    this.setState({
      renderModal: (
        <PointExpireLogDetailContainer
          id={row._id}
          onRepaired={this.handleRepaired}
          onClose={this.handleCloseModal}
        />
      ),
    });
  };

  handleRepaired = () => {
    this.handleCloseModal();
    this.handleReloadCurrentPage();
  };

  handleExport = async () => {
    const { filterQuery } = this.state;
    // กันกดซ้ำระหว่างรอ API (ดึงทั้งหมด pagination=false อาจใช้เวลา)
    if (this.isExporting) return;
    this.isExporting = true;
    this.setState({ isBgLoading: true });
    let joinQuery = filterQuery
      ? `${filterQuery}&pagination=false`
      : `?pagination=false`;
    let res = await portalService.GET_POINT_EXPIRE_LOG_LIST(joinQuery);
    this.isExporting = false;
    this.setState({ isBgLoading: false });
    if (!res || res.status !== 200) {
      toast.error('Export ไม่สำเร็จ');
      return;
    }
    var wb = XLSX.utils.book_new();
    var ws_name = 'SheetJS';
    var ws_data = res.data.docs.map(POINT_EXPIRE_LOG_SHEET_ROW);
    ws_data.splice(0, 0, POINT_EXPIRE_LOG_SHEET_HEADER);
    var ws = XLSX.utils.aoa_to_sheet(ws_data);
    ws['!cols'] = POINT_EXPIRE_LOG_SHEET_COLS;
    XLSX.utils.book_append_sheet(wb, ws, ws_name);
    XLSX.writeFile(
      wb,
      `Point expire history ${moment().tz(TIME_ZONE).format('DD-MM-YYYY')}.xlsx`
    );
  };

  render() {
    const {
      isLoading,
      isBgLoading,
      isPeriodLoading,
      periodOptions,
      pagination,
      data,
      filterValues,
      filterKey,
      renderModal,
    } = this.state;

    return (
      <PointExpireHistoryContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        {filterValues.run_ref_id && (
          <div className="run_filter_bar">
            <MdFilterAlt size={16} />
            <span>
              กรองตามรอบตัดแต้ม: <b>{this.renderRunLabel()}</b>
            </span>
            <div className="btn_clear_run">
              <Buttons.BgStandard
                theme_gray
                label="ล้างการกรองรอบ"
                onClick={this.handleClearRunFilter}
              />
            </div>
          </div>
        )}
        <div className="filter_layout">
          {!isPeriodLoading && (
            <Inputs.InputFilter
              key={filterKey}
              theme_standard_input_filter
              dataFilter={dataFilter(filterValues, periodOptions)}
              btnLabel="ค้นหา"
              clearLabel="ล้างค่า"
              onQueryFilter={this.handleFilterKeyword}
              onClear={this.handleClearFilter}
              onExport={this.handleExport}
            />
          )}
        </div>
        {isLoading ? (
          <Displays.Loading theme_standard_loading heightLayout="470px" />
        ) : (
          <div className="table_wrap">
            <Tables.Standard
              columns={columns}
              data={data}
              onRowClick={this.handleClickDetail}
              showPagination
              pagination={pagination}
              handlePageClick={this.handlePageClick}
            />
          </div>
        )}
        <Modals.BodyEmpty
          isShowModal={renderModal}
          onCloseModal={this.handleCloseModal}
        >
          {renderModal}
        </Modals.BodyEmpty>
      </PointExpireHistoryContainerStyled>
    );
  }
}

const dataFilter = (filterValues, periodOptions) => [
  {
    accessor: 'period_key',
    length: '360px',
    filter: {
      fieldQuery: 'period_key',
      type: 'dropdown',
      defaultValue: filterValues.period_key,
      options: periodOptions,
      placeholder: 'ล็อต',
      label: 'ล็อต : ',
    },
  },
  {
    accessor: 'user_id',
    length: '220px',
    filter: {
      fieldQuery: 'user_id',
      type: 'text',
      defaultValue: filterValues.user_id,
      label: 'Login ID : ',
      placeholder: 'Login ID',
    },
  },
  {
    accessor: 'customer_cu_id',
    length: '180px',
    filter: {
      fieldQuery: 'customer_cu_id',
      type: 'text',
      defaultValue: filterValues.customer_cu_id,
      label: 'CU code : ',
      placeholder: 'CU code',
    },
  },
  {
    accessor: 'status',
    length: '180px',
    filter: {
      fieldQuery: 'status',
      type: 'dropdown',
      defaultValue: filterValues.status,
      options: LOG_STATUS_OPTIONS,
      placeholder: 'สถานะ',
      label: 'สถานะ : ',
    },
  },
  {
    accessor: 'is_mismatch',
    length: '180px',
    filter: {
      fieldQuery: 'is_mismatch',
      type: 'dropdown',
      defaultValue: filterValues.is_mismatch,
      options: MISMATCH_OPTIONS,
      placeholder: 'ยอดไม่ตรง',
      label: 'ยอดไม่ตรง : ',
    },
  },
  {
    accessor: 'date',
    filter: {
      fieldQuery: 'date',
      type: 'dateRank',
      defaultStartValue: filterValues.start_date,
      defaultEndValue: filterValues.end_date,
      label: 'วันที่ตัด : ',
    },
  },
];

const numberCell = (props) => (
  <div style={{ textAlign: 'right' }}>{formatPoint(props.value)}</div>
);

const columns = [
  {
    Header: <div style={{ textAlign: 'left' }}>วันที่ตัด</div>,
    accessor: 'expired_run_at',
    Cell: (props) => (
      <div className="nowrap">
        {formatDateTime(props.value || props.row.original.created_at)}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Login ID</div>,
    accessor: 'customer_user_id',
    Cell: (props) => props.value || '-',
  },
  {
    Header: <div style={{ textAlign: 'left' }}>CU code</div>,
    accessor: 'customer_cu_id',
    Cell: (props) => props.value || '-',
  },
  {
    Header: <div style={{ textAlign: 'left' }}>ล็อต</div>,
    accessor: 'period_key',
  },
  {
    Header: <div style={{ textAlign: 'right' }}>ได้รับ</div>,
    accessor: 'lot_received',
    Cell: numberCell,
  },
  {
    Header: <div style={{ textAlign: 'right' }}>ใช้ไป</div>,
    accessor: 'lot_redeemed',
    Cell: numberCell,
  },
  {
    Header: <div style={{ textAlign: 'right' }}>คงเหลือ</div>,
    accessor: 'lot_remaining',
    Cell: numberCell,
  },
  {
    Header: <div style={{ textAlign: 'right' }}>Wallet ก่อน</div>,
    accessor: 'wallet_point_before',
    Cell: numberCell,
  },
  {
    Header: <div style={{ textAlign: 'right' }}>ตัด</div>,
    accessor: 'expired_point',
    Cell: (props) => (
      <div style={{ textAlign: 'right' }} className="expire_value">
        {formatPoint(props.value)}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'right' }}>Wallet หลัง</div>,
    accessor: 'wallet_point_after',
    Cell: (props) => (
      <div style={{ textAlign: 'right' }}>
        {props.value === undefined || props.value === null
          ? '-'
          : formatPoint(props.value)}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'center' }}>ยอดไม่ตรง</div>,
    accessor: 'is_mismatch',
    Cell: (props) => (
      <div style={{ textAlign: 'center' }}>
        {props.value ? (
          <span
            className="flag_mismatch"
            title={props.row.original.mismatch_reason || ''}
          >
            <MdWarningAmber size={14} />
            ไม่ตรง
          </span>
        ) : (
          '-'
        )}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'center' }}>สถานะ</div>,
    accessor: 'status',
    Cell: (props) => (
      <div style={{ textAlign: 'center' }}>
        <span className={`status_badge status_${props.value}`}>
          {RENDER_LOG_STATUS(props.value)}
        </span>
        {props.row.original.error_message && (
          <div className="error_text" title={props.row.original.error_message}>
            {props.row.original.error_message}
          </div>
        )}
      </div>
    ),
  },
];

export default withRouter(PointExpireHistoryContainer);
